import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './dark.css';
import { applyTheme, initialTheme } from './components/ThemeToggle';

// применяем тему до первой отрисовки, чтобы не было вспышки
applyTheme(initialTheme());
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();